import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ThemeProvider } from './theme/ThemeProvider';
import HomePage from './pages/HomePage';
import SettingsPage from './pages/SettingsPage';

import Header from './components/Header';
import Footer from './components/Footer';
import ModalRoot from './components/Sheet/ModalRoot';

function App() {
  return (
    <ThemeProvider>
      <Header />
      <div className="app-shell">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors />
        <ModalRoot />
      </div>
      <Footer />
    </ThemeProvider>
  );
}

export default App;
